// extracted by mini-css-extract-plugin
export default {"appWrapper":"App_appWrapper__p-V5m","pageContent":"App_pageContent__S6r43"};